// GCC — Group Chat with Catchy (62_Gcc.jsx), 2026-10-27. "Catchy" and "GCC" are names and stay as they are.
const en = {
  camera: "Take a photo",
  bellRoomsHead: "Every message, room by room",
  bellRoomsNote: "Ticked: each new message in that room rings your bell (one line per room). Unticked: only messages that @mention you. Only for you.",
  schedTomorrowAt: "Tomorrow at {{time}}",
  schedMondayAt: "Next Monday at {{time}}",
  schedCustom: "Pick a custom time",
  format: "Formatting",
  fmtBold: "Bold",
  fmtItalic: "Italic",
  fmtUnderline: "Underline",
  fmtStrike: "Strikethrough",
  fmtCode: "Code",
  fmtBullets: "Bulleted list",
  fmtNumbers: "Numbered list",
  tagAll: "@all — everybody in this room",
  deskOn: "Desktop alerts on",
  deskOff: "Desktop alerts",
  deskHint: "Show a pop-up on this computer when a new message arrives while the portal is open in any tab.",
  deskDenied: "The browser blocked notifications for this site. Allow them in the browser’s site settings (the lock icon beside the address), then try again.",
  deskUnsupported: "This browser cannot show desktop notifications.",
  schedule: "Schedule send",
  schedGo: "Schedule",
  schedN: "Scheduled by you ({{n}})",
  schedSendNow: "Send now",
  schedCancel: "Cancel",
  reply: "Reply",
  edit: "Edit",
  edited: "edited",
  replyingTo: "Replying to {{name}}",
  editHint: "Enter to save · Esc to cancel",
  emptyEdit: "A message cannot be empty.",
  jumpTo: "Go to the message",
  youTag: "(you)",
  membersTitle: "People in this room",
  remove: "Remove",
  onlyOwnerRemoves: "Only the room owner can remove people.",
  confirmRemove: "Remove {{name}} from \"{{room}}\"? They will no longer see this room; their messages stay.",
  download: 'Download',
  close: 'Close',
  prevImage: 'Previous picture',
  nextImage: 'Next picture',
  nav: 'Catchy Chat (Group)',   // Jay 30/10: "Please change name to 'Catchy Chat (Group)'"
  title: 'Group Chat with Catchy',
  sub: 'Rooms where colleagues write to each other. Catchy follows the chat and posts what may help in the side window; write @Catchy to ask it directly in the room.',
  newRoom: 'New room',
  rooms: 'Rooms',
  noRooms: 'No rooms yet. Start one and add the people you work with.',
  pickRoom: 'Pick a room on the left, or start a new one.',
  roomName: 'Room name',
  roomNamePh: 'e.g. S27 Costco chair',
  people: 'People',
  searchPeople: 'Search people…',
  picked: '{{n}} picked',
  create: 'Create room',
  cancel: 'Cancel',
  save: 'Save',
  addPeople: 'Add people',
  add: 'Add',
  rename: 'Rename',
  leave: 'Leave',
  deleteRoom: 'Delete room',
  confirmLeave: 'Leave "{{name}}"? You will no longer see its messages.',
  confirmDelete: 'Delete "{{name}}" for everybody in it?',
  members: '{{n}} people',
  owner: 'owner',
  side: 'Catchy side window',
  sideOn: 'On',
  sideOff: 'Off',
  sideTitle: 'Catchy live',
  sideSub: 'Catchy follows the chat and posts here when it has something useful — nobody needs to tag it.',
  readsNote: 'Catchy reads this chat to find issues and ideas for the Portal.',
  sideEmpty: 'Nothing yet. Catchy posts here when the conversation touches something it can help with.',
  sideWatching: 'Catchy is reading the chat…',
  answering: 'Catchy is answering…',
  placeholder: 'Write a message… (Enter to send, Shift+Enter for a new line, @Catchy to ask Catchy)',
  send: 'Send',
  mention: '@Catchy',
  sources: 'Sources',
  you: 'You',
  unread: '{{n}} new',
  noMessages: 'No messages yet — say hello.',
  aiMark: 'Written by AI (Catchy)',
  mailed: 'Invitation emailed to {{n}} people.',
  sideLast: 'Read the chat at {{t}} — nothing new to add.',
  quickAdd: 'Quick add:',
  chipDepts: 'Departments',
  chipEntities: 'Entities',
  dropNone: 'choose…',
  addDept: '+ a whole department…',
  addEntity: '+ a whole entity…',
  clearPicked: 'Clear',
  trUnclear: "The original is unclear, so the translation keeps it unclear rather than guess.",
  trUnclearShort: "unclear in the original",
  translated: "Translated by AI · show original",
  showTranslation: "Original · show translation",
  catchyLive: "Live",
  catchySleeping: "Sleeping",
  catchyOnHint: "Catchy is on for this room: it follows the chat and answers @Catchy. Switch off to stop it (no AI use).",
  catchyOffHint: "Catchy is off for this room: it does not read the chat, post or use AI. Switch on to wake it.",
  offTitle: "Catchy is off",
  offLine: "It is not reading this chat.",
  turnOn: "Turn Catchy on",
  turnOnToAsk: "Turn Catchy on to ask",
  placeholderOff: "Write a message… (Enter to send, Shift+Enter for a new line — Catchy is off)",
  asleepHint: "Catchy is off, so it will not answer. Turn Catchy on to ask.",
  sideCollapse: "Fold the Catchy live window",
  sideExpand: "Open the Catchy live window",
  trSwitch: "Translate",
  trOnHint: "Messages are shown in your portal language from the moment you turned this on. Off: nothing is translated for you.",
  trOffHint: "Off: you read every message as it was written, and no translation is made for you.",
  trAbove: "Translate the messages above",
  emoji: "Emoji",
  react: "React",
  attach: "Attach a file or image (you can also paste a screenshot with Ctrl+V, or drop files here)",
  removeFile: "Remove",
  fileTooBig: "{{name}} is over 20 MB.",
  uploading: "Uploading…",
};

const ko = {
  camera: "사진 찍기",
  bellRoomsHead: "모든 메시지 알림 (채팅방별)",
  bellRoomsNote: "체크: 그 방의 새 메시지마다 알림이 울립니다 (방마다 한 줄). 해제: 나를 @멘션한 메시지만. 나에게만 적용됩니다.",
  schedTomorrowAt: "내일 {{time}}",
  schedMondayAt: "다음 주 월요일 {{time}}",
  schedCustom: "직접 시간 선택",
  format: "서식",
  fmtBold: "굵게",
  fmtItalic: "기울임꼴",
  fmtUnderline: "밑줄",
  fmtStrike: "취소선",
  fmtCode: "코드",
  fmtBullets: "글머리 기호 목록",
  fmtNumbers: "번호 매기기 목록",
  tagAll: "@all — 이 방의 모든 사람",
  deskOn: "데스크톱 알림 켜짐",
  deskOff: "데스크톱 알림",
  deskHint: "포털이 어느 탭에서든 열려 있을 때 새 메시지가 오면 이 컴퓨터에 팝업을 띄웁니다.",
  deskDenied: "브라우저가 이 사이트의 알림을 차단했습니다. 주소창 옆 자물쇠 아이콘의 사이트 설정에서 허용한 뒤 다시 시도하세요.",
  deskUnsupported: "이 브라우저는 데스크톱 알림을 지원하지 않습니다.",
  schedule: "예약 전송",
  schedGo: "예약",
  schedN: "내 예약 메시지 ({{n}})",
  schedSendNow: "지금 보내기",
  schedCancel: "취소",
  reply: "답장",
  edit: "수정",
  edited: "수정됨",
  replyingTo: "{{name}} 님에게 답장",
  editHint: "Enter 저장 · Esc 취소",
  emptyEdit: "메시지는 비워 둘 수 없습니다.",
  jumpTo: "원래 메시지로 이동",
  youTag: "(나)",
  membersTitle: "이 방의 사람들",
  remove: "내보내기",
  onlyOwnerRemoves: "방장만 사람을 내보낼 수 있습니다.",
  confirmRemove: "{{name}} 님을 \"{{room}}\" 방에서 내보내시겠습니까? 더 이상 이 방을 볼 수 없으며, 보낸 메시지는 남습니다.",
  download: '다운로드',
  close: '닫기',
  prevImage: '이전 사진',
  nextImage: '다음 사진',
  nav: 'Catchy Chat (그룹)',
  title: 'Catchy와 그룹 채팅',
  sub: '동료들이 서로 대화하는 방입니다. Catchy가 대화를 따라가며 도움이 될 내용을 옆 창에 올립니다. 방 안에서 바로 물어보려면 @Catchy 라고 쓰세요.',
  newRoom: '새 방',
  rooms: '방 목록',
  noRooms: '아직 방이 없습니다. 함께 일하는 사람들과 방을 만들어 보세요.',
  pickRoom: '왼쪽에서 방을 고르거나 새 방을 만드세요.',
  roomName: '방 이름',
  roomNamePh: '예: S27 Costco 체어',
  people: '참여자',
  searchPeople: '사람 검색…',
  picked: '{{n}}명 선택',
  create: '방 만들기',
  cancel: '취소',
  save: '저장',
  addPeople: '사람 추가',
  add: '추가',
  rename: '이름 변경',
  leave: '나가기',
  deleteRoom: '방 삭제',
  confirmLeave: '"{{name}}" 방에서 나가시겠습니까? 이 방의 메시지를 더 이상 볼 수 없습니다.',
  confirmDelete: '"{{name}}" 방을 모든 참여자에게서 삭제하시겠습니까?',
  members: '{{n}}명',
  owner: '방장',
  side: 'Catchy 옆 창',
  sideOn: '켜짐',
  sideOff: '꺼짐',
  sideTitle: 'Catchy 라이브',
  sideSub: 'Catchy가 대화를 따라가며 도움이 될 때 여기에 올립니다. 태그하지 않아도 됩니다.',
  readsNote: 'Catchy는 포털의 문제점과 개선 아이디어를 찾기 위해 이 채팅을 읽습니다.',
  sideEmpty: '아직 없습니다. 대화가 Catchy가 도울 수 있는 내용에 닿으면 여기에 올라옵니다.',
  sideWatching: 'Catchy가 대화를 읽는 중…',
  answering: 'Catchy가 답하는 중…',
  placeholder: '메시지 입력… (Enter 전송, Shift+Enter 줄바꿈, @Catchy 로 Catchy에게 질문)',
  send: '보내기',
  mention: '@Catchy',
  sources: '출처',
  you: '나',
  unread: '새 메시지 {{n}}',
  noMessages: '아직 메시지가 없습니다. 인사를 건네 보세요.',
  aiMark: 'AI(Catchy)가 작성',
  mailed: '{{n}}명에게 초대 메일을 보냈습니다.',
  sideLast: '{{t}}에 대화를 읽음 — 추가할 내용 없음.',
  quickAdd: '빠른 추가:',
  chipDepts: '부서',
  chipEntities: '법인',
  dropNone: '선택…',
  addDept: '+ 부서 전체…',
  addEntity: '+ 법인 전체…',
  clearPicked: '선택 해제',
  trUnclear: "원문의 뜻이 분명하지 않아, 추측하지 않고 그대로 모호하게 옮겼습니다.",
  trUnclearShort: "원문이 모호함",
  translated: "AI 번역 · 원문 보기",
  showTranslation: "원문 · 번역 보기",
  catchyLive: "라이브",
  catchySleeping: "휴면",
  catchyOnHint: "이 방에서 Catchy가 켜져 있습니다: 대화를 따라가며 @Catchy에 답합니다. 끄면 멈춥니다(AI 사용 없음).",
  catchyOffHint: "이 방에서 Catchy가 꺼져 있습니다: 대화를 읽거나 게시하지 않고 AI도 사용하지 않습니다. 켜면 다시 작동합니다.",
  offTitle: "Catchy 꺼짐",
  offLine: "이 대화를 읽지 않습니다.",
  turnOn: "Catchy 켜기",
  turnOnToAsk: "질문하려면 Catchy를 켜세요",
  placeholderOff: "메시지 입력… (Enter 전송, Shift+Enter 줄바꿈 — Catchy 꺼짐)",
  asleepHint: "Catchy가 꺼져 있어 답하지 않습니다. 질문하려면 Catchy를 켜세요.",
  sideCollapse: "Catchy 라이브 창 접기",
  sideExpand: "Catchy 라이브 창 열기",
  trSwitch: "번역",
  trOnHint: "켠 시점부터 메시지를 포털 언어로 보여줍니다. 끄면 번역하지 않습니다.",
  trOffHint: "꺼짐: 모든 메시지를 원문으로 보며, 번역을 하지 않습니다.",
  trAbove: "위 메시지 번역하기",
  emoji: "이모지",
  react: "반응",
  attach: "파일·이미지 첨부 (Ctrl+V로 스크린샷 붙여넣기, 끌어다 놓기도 가능)",
  removeFile: "삭제",
  fileTooBig: "{{name}} 파일이 20MB를 넘습니다.",
  uploading: "업로드 중…",
};

const vi = {
  camera: "Chụp ảnh",
  bellRoomsHead: "Mọi tin nhắn, theo từng phòng",
  bellRoomsNote: "Có tick: mỗi tin mới trong phòng đó đều báo chuông (mỗi phòng 1 dòng). Bỏ tick: chỉ tin @nhắc tên bạn. Chỉ áp dụng cho riêng bạn.",
  schedTomorrowAt: "Ngày mai lúc {{time}}",
  schedMondayAt: "Thứ Hai tới lúc {{time}}",
  schedCustom: "Chọn thời gian khác",
  format: "Định dạng",
  fmtBold: "In đậm",
  fmtItalic: "In nghiêng",
  fmtUnderline: "Gạch dưới",
  fmtStrike: "Gạch ngang",
  fmtCode: "Mã",
  fmtBullets: "Danh sách gạch đầu dòng",
  fmtNumbers: "Danh sách đánh số",
  tagAll: "@all — mọi người trong phòng",
  deskOn: "Đã bật thông báo desktop",
  deskOff: "Thông báo desktop",
  deskHint: "Hiện thông báo trên máy tính khi có tin nhắn mới, miễn là portal đang mở ở một tab bất kỳ.",
  deskDenied: "Trình duyệt đang chặn thông báo của trang này. Hãy cho phép trong cài đặt trang (biểu tượng ổ khóa cạnh địa chỉ) rồi thử lại.",
  deskUnsupported: "Trình duyệt này không hiện được thông báo desktop.",
  schedule: "Hẹn giờ gửi",
  schedGo: "Hẹn giờ",
  schedN: "Tin bạn đã hẹn giờ ({{n}})",
  schedSendNow: "Gửi ngay",
  schedCancel: "Hủy",
  reply: "Trả lời",
  edit: "Sửa",
  edited: "đã sửa",
  replyingTo: "Đang trả lời {{name}}",
  editHint: "Enter để lưu · Esc để huỷ",
  emptyEdit: "Tin nhắn không được để trống.",
  jumpTo: "Đến tin nhắn gốc",
  youTag: "(bạn)",
  membersTitle: "Người trong phòng",
  remove: "Xoá khỏi phòng",
  onlyOwnerRemoves: "Chỉ chủ phòng mới xoá được người khỏi phòng.",
  confirmRemove: "Xoá {{name}} khỏi phòng \"{{room}}\"? Người này sẽ không còn thấy phòng; tin nhắn đã gửi vẫn giữ.",
  download: 'Tải về',
  close: 'Đóng',
  prevImage: 'Ảnh trước',
  nextImage: 'Ảnh sau',
  nav: 'Catchy Chat (Nhóm)',
  title: 'Chat nhóm với Catchy',
  sub: 'Phòng để đồng nghiệp nhắn tin với nhau. Catchy theo dõi cuộc trò chuyện và đăng thông tin hữu ích ở cửa sổ bên cạnh; gõ @Catchy để hỏi Catchy ngay trong phòng.',
  newRoom: 'Phòng mới',
  rooms: 'Phòng',
  noRooms: 'Chưa có phòng nào. Tạo một phòng và thêm những người bạn làm việc cùng.',
  pickRoom: 'Chọn một phòng bên trái, hoặc tạo phòng mới.',
  roomName: 'Tên phòng',
  roomNamePh: 'VD: Ghế S27 Costco',
  people: 'Thành viên',
  searchPeople: 'Tìm người…',
  picked: 'Đã chọn {{n}}',
  create: 'Tạo phòng',
  cancel: 'Huỷ',
  save: 'Lưu',
  addPeople: 'Thêm người',
  add: 'Thêm',
  rename: 'Đổi tên',
  leave: 'Rời phòng',
  deleteRoom: 'Xoá phòng',
  confirmLeave: 'Rời phòng "{{name}}"? Bạn sẽ không còn thấy tin nhắn trong phòng này.',
  confirmDelete: 'Xoá phòng "{{name}}" với mọi thành viên?',
  members: '{{n}} người',
  owner: 'chủ phòng',
  side: 'Cửa sổ Catchy',
  sideOn: 'Bật',
  sideOff: 'Tắt',
  sideTitle: 'Catchy trực tiếp',
  sideSub: 'Catchy theo dõi cuộc trò chuyện và đăng ở đây khi có gì hữu ích — không cần tag.',
  readsNote: 'Catchy đọc nhóm chat này để tìm vấn đề và ý tưởng cải thiện Portal.',
  sideEmpty: 'Chưa có gì. Catchy sẽ đăng ở đây khi cuộc trò chuyện chạm tới điều nó giúp được.',
  sideWatching: 'Catchy đang đọc cuộc trò chuyện…',
  answering: 'Catchy đang trả lời…',
  placeholder: 'Nhập tin nhắn… (Enter để gửi, Shift+Enter xuống dòng, @Catchy để hỏi Catchy)',
  send: 'Gửi',
  mention: '@Catchy',
  sources: 'Nguồn',
  you: 'Bạn',
  unread: '{{n}} mới',
  noMessages: 'Chưa có tin nhắn — hãy chào mọi người.',
  aiMark: 'Do AI (Catchy) viết',
  mailed: 'Đã gửi email mời cho {{n}} người.',
  sideLast: 'Đã đọc cuộc trò chuyện lúc {{t}} — chưa có gì mới để thêm.',
  quickAdd: 'Thêm nhanh:',
  chipDepts: 'Department',
  chipEntities: 'Entity',
  dropNone: 'chọn…',
  addDept: '+ cả department…',
  addEntity: '+ cả entity…',
  clearPicked: 'Bỏ chọn',
  trUnclear: "Câu gốc chưa rõ nghĩa, nên bản dịch giữ nguyên sự mơ hồ thay vì đoán.",
  trUnclearShort: "câu gốc chưa rõ",
  translated: "Đã dịch bằng AI · xem bản gốc",
  showTranslation: "Bản gốc · xem bản dịch",
  catchyLive: "Đang bật",
  catchySleeping: "Đang ngủ",
  catchyOnHint: "Catchy đang bật cho phòng này: theo dõi cuộc trò chuyện và trả lời @Catchy. Tắt để dừng (không dùng AI).",
  catchyOffHint: "Catchy đang tắt cho phòng này: không đọc chat, không đăng, không dùng AI. Bật để đánh thức.",
  offTitle: "Catchy đang tắt",
  offLine: "Catchy không đọc cuộc trò chuyện này.",
  turnOn: "Bật Catchy",
  turnOnToAsk: "Bật Catchy để hỏi",
  placeholderOff: "Nhập tin nhắn… (Enter để gửi, Shift+Enter xuống dòng — Catchy đang tắt)",
  asleepHint: "Catchy đang tắt nên sẽ không trả lời. Bật Catchy để hỏi.",
  sideCollapse: "Thu gọn cửa sổ Catchy live",
  sideExpand: "Mở cửa sổ Catchy live",
  trSwitch: "Dịch",
  trOnHint: "Tin nhắn hiện theo ngôn ngữ portal của bạn kể từ lúc bật. Tắt: không dịch gì cho bạn.",
  trOffHint: "Tắt: bạn đọc tin nhắn đúng như người viết, không có lượt dịch nào cho bạn.",
  trAbove: "Dịch các tin nhắn phía trên",
  emoji: "Emoji",
  react: "Thả cảm xúc",
  attach: "Đính kèm file hoặc hình (dán ảnh chụp màn hình bằng Ctrl+V, hoặc kéo thả file vào đây)",
  removeFile: "Bỏ",
  fileTooBig: "{{name}} lớn hơn 20 MB.",
  uploading: "Đang tải lên…",
};

const zh = {
  camera: "拍照",
  bellRoomsHead: "所有消息（按聊天室）",
  bellRoomsNote: "勾选：该聊天室的每条新消息都会提醒你（每个聊天室一行）。不勾选：只提醒 @ 你的消息。仅对你本人生效。",
  schedTomorrowAt: "明天 {{time}}",
  schedMondayAt: "下周一 {{time}}",
  schedCustom: "自定义时间",
  format: "格式",
  fmtBold: "加粗",
  fmtItalic: "斜体",
  fmtUnderline: "下划线",
  fmtStrike: "删除线",
  fmtCode: "代码",
  fmtBullets: "项目符号列表",
  fmtNumbers: "编号列表",
  tagAll: "@all — 聊天室里的所有人",
  deskOn: "桌面通知已开启",
  deskOff: "桌面通知",
  deskHint: "只要门户在任一标签页中打开，有新消息时就在这台电脑上弹出通知。",
  deskDenied: "浏览器已阻止此网站的通知。请在地址栏旁锁形图标的网站设置中允许，然后重试。",
  deskUnsupported: "此浏览器无法显示桌面通知。",
  schedule: "定时发送",
  schedGo: "定时",
  schedN: "你的定时消息（{{n}}）",
  schedSendNow: "立即发送",
  schedCancel: "取消",
  reply: "回复",
  edit: "编辑",
  edited: "已编辑",
  replyingTo: "回复 {{name}}",
  editHint: "Enter 保存 · Esc 取消",
  emptyEdit: "消息不能为空。",
  jumpTo: "转到原消息",
  youTag: "（我）",
  membersTitle: "本群成员",
  remove: "移除",
  onlyOwnerRemoves: "只有群主可以移除成员。",
  confirmRemove: "将 {{name}} 移出“{{room}}”？对方将看不到此群，已发的消息会保留。",
  download: '下载',
  close: '关闭',
  prevImage: '上一张',
  nextImage: '下一张',
  nav: 'Catchy Chat（群组）',
  title: '与 Catchy 群聊',
  sub: '同事之间互相交流的聊天室。Catchy 会跟进对话，并在侧边窗口发布可能有用的信息；在聊天室中输入 @Catchy 可直接提问。',
  newRoom: '新建聊天室',
  rooms: '聊天室',
  noRooms: '还没有聊天室。新建一个并添加一起工作的同事吧。',
  pickRoom: '从左侧选择一个聊天室，或新建一个。',
  roomName: '聊天室名称',
  roomNamePh: '例如：S27 Costco 椅子',
  people: '成员',
  searchPeople: '搜索成员…',
  picked: '已选 {{n}} 人',
  create: '创建聊天室',
  cancel: '取消',
  save: '保存',
  addPeople: '添加成员',
  add: '添加',
  rename: '重命名',
  leave: '退出',
  deleteRoom: '删除聊天室',
  confirmLeave: '退出“{{name}}”？之后将看不到其中的消息。',
  confirmDelete: '为所有成员删除“{{name}}”？',
  members: '{{n}} 人',
  owner: '创建者',
  side: 'Catchy 侧边窗口',
  sideOn: '开',
  sideOff: '关',
  sideTitle: 'Catchy 直播',
  sideSub: 'Catchy 跟进对话，有有用的信息时会发在这里——无需 @ 它。',
  readsNote: 'Catchy 会阅读此聊天，以发现 Portal 的问题和改进想法。',
  sideEmpty: '暂时没有。当对话涉及 Catchy 能帮上忙的内容时，会发在这里。',
  sideWatching: 'Catchy 正在阅读对话…',
  answering: 'Catchy 正在回答…',
  placeholder: '输入消息…（Enter 发送，Shift+Enter 换行，@Catchy 向 Catchy 提问）',
  send: '发送',
  mention: '@Catchy',
  sources: '来源',
  you: '我',
  unread: '{{n}} 条新消息',
  noMessages: '还没有消息——打个招呼吧。',
  aiMark: '由 AI（Catchy）撰写',
  mailed: '已向 {{n}} 人发送邀请邮件。',
  sideLast: '{{t}} 已阅读对话——暂无新内容。',
  quickAdd: '快速添加：',
  chipDepts: '部门',
  chipEntities: '法人',
  dropNone: '选择…',
  addDept: '+ 整个部门…',
  addEntity: '+ 整个法人…',
  clearPicked: '清除',
  trUnclear: "原文意思不明确，译文保持原样，不作猜测。",
  trUnclearShort: "原文含义不明",
  translated: "AI 翻译 · 查看原文",
  showTranslation: "原文 · 查看译文",
  catchyLive: "运行中",
  catchySleeping: "休眠",
  catchyOnHint: "此聊天室的 Catchy 已开启：跟进对话并回答 @Catchy。关闭即停止（不使用 AI）。",
  catchyOffHint: "此聊天室的 Catchy 已关闭：不读对话、不发帖、不使用 AI。开启即可唤醒。",
  offTitle: "Catchy 已关闭",
  offLine: "它不会读取此对话。",
  turnOn: "开启 Catchy",
  turnOnToAsk: "开启 Catchy 后才能提问",
  placeholderOff: "输入消息…（Enter 发送，Shift+Enter 换行 — Catchy 已关闭）",
  asleepHint: "Catchy 已关闭，不会回答。开启 Catchy 后才能提问。",
  sideCollapse: "收起 Catchy 直播窗口",
  sideExpand: "展开 Catchy 直播窗口",
  trSwitch: "翻译",
  trOnHint: "从开启时起，消息以您的门户语言显示。关闭：不为您翻译。",
  trOffHint: "关闭：按原文阅读所有消息，不为您进行翻译。",
  trAbove: "翻译上面的消息",
  emoji: "表情",
  react: "回应",
  attach: "附加文件或图片（也可用 Ctrl+V 粘贴截图，或拖放文件）",
  removeFile: "移除",
  fileTooBig: "{{name}} 超过 20 MB。",
  uploading: "上传中…",
};

const dictionary = { ns: 'xGcc', en, ko, vi, zh };
export default dictionary;
